<template>
  <div
    class="locale_btns"
    :class="{active_lang_dark: active_lang_darker}">
    <button v-for="lang in getLanguages"
            type="button"
            :class="{active: getSelectedLanguage === lang}"
            @click="changeLanguage(lang)">
      {{ lang.toUpperCase() }}
    </button>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ChangeLocale",
  props: {
    active_lang_darker: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapGetters([
      'getLanguages',
      'getSelectedLanguage',
    ]),
  },
  methods: {
    ...mapActions([
      'actionChangeLocale'
    ]),
    changeLanguage (lang) {
      this.actionChangeLocale({vue: this, lang: lang})
      let html = document.querySelector('html')
      if (!html) return
      html.lang = lang
    },
  }
}
</script>
